import React from 'react';
import { SubNavigationSidebar } from 'components/SubNavigationSidebar';
import TwoColumnsCardSidebar from 'components/TwoColumnsCardSidebar';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { routes } from 'containers/routes';
import { MenuItemProps } from 'components/NavLink/MenuItem';
import { ParseKeys } from 'i18next';
import { useTranslation } from 'react-i18next';
import {
  BuildingLibraryIcon,
  CalendarIcon as Calendar,
  Cog8ToothIcon,
} from '@heroicons/react/24/outline';
import { Schoolyear } from 'types/schoolyear';

type I18nTitleKey = Extract<
  ParseKeys<'schoolyearSettings', {}, undefined>,
  `schoolyearSubmenu.${string}`
>;
const menuItems: (Omit<MenuItemProps, 'title'> & { title: I18nTitleKey })[] = [
  {
    route: 'general',
    icon: BuildingLibraryIcon,
    title: 'schoolyearSubmenu.mySchools',
  },
  {
    route: 'holidays',
    icon: Calendar,
    title: 'schoolyearSubmenu.holidays',
  },
  {
    route: 'settings',
    icon: Cog8ToothIcon,
    title: 'schoolyearSubmenu.settings',
  },
];

interface Props {
  className?: string;
}

export function Sidebar(props: Props) {
  const { schoolyear } = useOutletContext<{
    schoolyear: Schoolyear;
  }>();
  const hasPeriodeError = (schoolyear?.errors || []).length > 0;
  const { t } = useTranslation(['schoolyearSettings']);
  const navigate = useNavigate();
  const location = useLocation();
  const route = location.pathname.split('/')[3];

  return (
    <TwoColumnsCardSidebar.Side className={props.className}>
      <SubNavigationSidebar
        items={menuItems.map(i => ({
          ...i,
          title:
            t(i.title) +
            (i.route === 'holidays' && hasPeriodeError ? ' ⚠️' : ''),
          route: `${routes.schoolyearSettings({
            schoolyearId: schoolyear.id,
          })}/${i.route}`,
        }))}
        goTo={navigate}
        currentRoute={`${routes.schoolyearSettings({
          schoolyearId: schoolyear.id,
        })}/${route}`}
      />
    </TwoColumnsCardSidebar.Side>
  );
}
